// Shared AppFolio occupancy-document sync DTO + the staff retry call. Mirrored
// from the API's OccupancyUploadDisplay; folded into every surface a doc appears on.

import { api } from './api';

export interface AppfolioSyncDisplay {
  /** The upload row's docKey — the retry target. */
  docKey: string;
  status: string;
  label: string;
  tone: 'success' | 'warning' | 'danger' | 'neutral';
  attachmentId?: string;
  error?: string;
  versionNum: number;
  /** Whether a staff retry applies (failed/stuck). */
  retryable: boolean;
}

/** Staff retry of a FAILED/STUCK upload — re-arms a fresh attempt (no duplicate). */
export async function retryOccupancyUpload(docKey: string): Promise<void> {
  await api.post(`/api/occupancy-uploads/${encodeURIComponent(docKey)}/retry`);
}
